import { useMemo } from 'react';
import { useConfigQuery } from 'utils/api/useConfigQuery';
import { replaceUrl } from 'utils/helpers/replaceUrl';

import { Frequency, FrequencyId } from '@/graphql/config';

export const DEFAULT_FREQUENCY_ID = FrequencyId.ONETIME;
export const DEFAULT_FREQUENCY_NAME = 'One Time';

export function useFrequency(language?: string) {
  const { data } = useConfigQuery(language);
  const recurringFrequencies = data?.frequencies?.filter(recurringFrequenciesFilter) ?? [];
  const isRecurring = Boolean(recurringFrequencies.some(isRecurringMap));

  return {
    frequencies: data?.frequencies,
    getFrequencyName: useMemo(() => getFrequencyName(data?.frequencies ?? []), [data?.frequencies]),
    isRecurring,
    recurringFrequencies,
    selectedFrequency: getSelectedFrequencyId(),
    setFrequency,
  };
}

function getFrequencyName(frequencies: Array<Frequency>) {
  return function (id: string) {
    return frequencies.find(f => f.id === id)?.name ?? DEFAULT_FREQUENCY_NAME;
  };
}

function isRecurringMap(frequency: Frequency) {
  return frequency.id === getSelectedFrequencyId();
}
function recurringFrequenciesFilter(item: Frequency) {
  return item.id !== DEFAULT_FREQUENCY_ID;
}

export function getSelectedFrequencyId() {
  if (typeof window === 'undefined') {
    return DEFAULT_FREQUENCY_ID;
  }
  return (new URLSearchParams(location.search).get('frequency') ?? DEFAULT_FREQUENCY_ID).toUpperCase() as FrequencyId;
}

async function setFrequency(frequency: string) {
  await replaceUrl({ frequency });
}
